import React from "react";

const PlayButton = () => {
    return (
        <svg
            width="85"
            height="85"
            viewBox="0 0 85 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M42.4929 7.0625C23.0013 7.0625 7.18213 22.8817 7.18213 42.3732C7.18213 61.8648 23.0013 77.684 42.4929 77.684C61.9844 77.684 77.8036 61.8648 77.8036 42.3732C77.8036 22.8817 61.9844 7.0625 42.4929 7.0625ZM35.431 58.2629L56.6175 42.3731L35.431 26.4833V58.2629ZM14.2446 42.3733C14.2446 57.9453 26.9212 70.6219 42.4932 70.6219C58.0652 70.6219 70.7418 57.9453 70.7418 42.3733C70.7418 26.8013 58.0652 14.1247 42.4932 14.1247C26.9212 14.1247 14.2446 26.8013 14.2446 42.3733Z"
                fill="white"
                fill-opacity="0.6"
            />
        </svg>
    );
};

export default PlayButton;
